import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { validateStudentSession } from '../services/authService';

export const isAuthenticated = () => {
  return !!localStorage.getItem('user_id') && !!localStorage.getItem('student_token');
};

export const isGuruAuthenticated = () => {
  return !!localStorage.getItem('guru_id') && !!localStorage.getItem('guru_api_token');
};

// Untuk route yang hanya bisa diakses jika sudah login
export const ProtectedRoute = ({ children }) => {
  const [, refresh] = useState(0);
  useEffect(() => {
    let cancelled = false;
    let checking = false;
    const check = async () => {
      if (checking || document.visibilityState === 'hidden') return;
      checking = true;
      const active = await validateStudentSession();
      checking = false;
      if (!cancelled && !active) refresh((value) => value + 1);
    };
    const storage = () => { refresh((value) => value + 1); check(); };
    check();
    const timer = window.setInterval(check, 30000);
    window.addEventListener('focus', check);
    window.addEventListener('storage', storage);
    document.addEventListener('visibilitychange', check);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
      window.removeEventListener('focus', check);
      window.removeEventListener('storage', storage);
      document.removeEventListener('visibilitychange', check);
    };
  }, []);
  return isAuthenticated() && localStorage.getItem('account_type') !== 'guru'
    ? children
    : <Navigate to={isGuruAuthenticated() ? '/guru' : '/login'} replace />;
};

export const GuruProtectedRoute = ({ children }) => {
  return isGuruAuthenticated()
    ? children
    : <Navigate to={isAuthenticated() ? '/dashboard' : '/login'} replace />;
};

// Untuk route seperti /login, tidak bisa diakses jika sudah login
export const RedirectIfAuthenticated = ({ children }) => {
  if (isGuruAuthenticated()) return <Navigate to="/guru" replace />;
  return isAuthenticated() ? <Navigate to="/dashboard" replace /> : children;
};
